import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  TransferRequestDialog,
  TransferRequestDialogCallbackInput,
  TransferRequestUniqueProps,
} from '../transfer-request-hook-dialog';

const { useDialogForContext, useDialog: useTransferRequestDialog } =
  getDialogHooks<
    TransferRequestUniqueProps,
    TransferRequestDialogCallbackInput
  >(TransferRequestDialog);
export const useTransferRequestDialogForContext = useDialogForContext;
export default useTransferRequestDialog;
